import "./App.css";
import { useEffect, useState } from "react";
import Home from "../src/components/home/home";
import Step1 from "../src/components/step-1/step-1";
import Step2 from "../src/components/step-2/step-2";
import Step3 from "../src/components/step-3/step-3";
import Step4 from "../src/components/step-4/step-4";
import Step5 from "../src/components/step-5/step-5";
import Step6 from "../src/components/step-6/step-6";
import Step7 from "../src/components/step-7/step-7";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import Loader from "./components/loader/loader";
import APIS from "../src/services/apis";
import { inicializarTagManager } from "./services/googleTagManager";
import TagManager from "react-gtm-module-nonce-aware";
import { Buffer } from "buffer";

function App() {
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingFinal, setLoadingFinal] = useState(true);
  const [backButton, setShowBackButton] = useState(false);
  const [tipoDoc, setTipoDoc] = useState(1);
  const [numDoc, setNumDoc] = useState("");
  const [email, setEmail] = useState("");
  const [captcha, setCaptcha] = useState(false);
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [fechaNac, setFechaNac] = useState("");
  const [telefono, setTelefono] = useState("");
  const [region, setRegion] = useState("");
  const [termycond, setTyc] = useState(false);
  const [carrera, setCarrera] = useState("");
  const [sede, setSede] = useState("");
  const [regiones, setRegiones] = useState([]);
  const [carreras, setCarreras] = useState([]);
  const [modalidades, setModalidades] = useState([]);
  const [estudiante, setEstudiante] = useState("");
  const [simulacion, setSimulacion] = useState("");
  const [carrera_modalidad_sede, setCarreraModalidadSede] = useState("");
  const [certificado, setCertificado] = useState("");
  const [permitir_envio, setPermitirEnvio] = useState(false);

  const [loader, setLoader] = useState(true);

  const [valor_matricula_anual, setValorMatriculaAnual] = useState("");
  const [valor_arancel_anual, setValorArancelAnual] = useState("");
  const [valor_beca_matricula_unab, setValorMatriculaUnab] = useState("");
  const [valor_beca_arancel_unab, setValorArancelUnab] = useState("");
  const [valor_matricula_anual_unab, setValorMatriculaAnualUnab] =
    useState("0");
  const [valor_anual_con_becas, setValorAnualConBecas] = useState("");
  const [valor_mensual_con_becas, setValorMensualConBecas] = useState("");
  const [valor_nombre_carrera, setValorNombreCarrera] = useState("");
  const [valor_sede, setValorSede] = useState("");
  const [url_pdf, setUrlPdf] = useState("");
  const [caracteristica_1, setCaracteristica_1] = useState("");
  const [caracteristica_2, setCaracteristica_2] = useState("");
  const [caracteristica_3, setCaracteristica_3] = useState("");

  const [tipoDocAlert, setTipoDocAlert] = useState("required");
  const [numDocAlert, setNumDocAlert] = useState("required empty");
  const [emailAlert, setEmailAlert] = useState("required empty");
  const [captchaAlert, setCaptchaAlert] = useState("required empty");
  const [nombreAlert, setNombreAlert] = useState("required empty");
  const [apellidoAlert, setApellidoAlert] = useState("required empty");
  const [fechaNacAlert, setFechaNacAlert] = useState("required empty");
  const [telefonoAlert, setTelefonoAlert] = useState(
    "required empty tel_input"
  );
  const [regionAlert, setRegionAlert] = useState("required");

  const [opening, setOpening] = useState(true);
  const [openingMsg, setOpeningMsg] = useState("");

  const [nueva_simulacion, setNuevaSimulacion] = useState(true);

  // CARGA PAGINA
  const startSimulacionPage0 = () => {
    inicializarTagManager();
    TagManager.dataLayer({
      dataLayer: {
        event: "checkout",
        pageType: "simulador-vespertino",
        ecommerce: {
          checkout: {
            actionField: {
              step: 1,
            },
          },
        },
      },
    });
  }

  // START FLUJO
  const startSimulacionPage1 = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "checkout",
        pageType: "simulador-vespertino",
        ecommerce: {
          checkout: {
            actionField: {
              step: 2
      }}}}
    });
    setPage(1);
  };

  // BEFORE STEP START
  const tagManagerStepper = (actualPage) => {
    const rutCompleto = numDoc
      .replaceAll(".", "")
      .replaceAll("-", "")
      .toLowerCase();
    const buffer = Buffer.from(rutCompleto);
    const encodedRut = buffer.toString("base64");
    const docActual = parseInt(tipoDoc) === 1 ? "RUT" : "PASAPORTE";
    let regActual;
    if (actualPage > 2) {
      regActual = regiones.find(
        ({ id_region }) => id_region === parseInt(region)
      );
    }
    let modalidadActual;
    if (actualPage > 3)
      modalidadActual = carreras.filter(({ carreras }) =>
        carreras.find(({ id_carrera }) => id_carrera === carrera.id_carrera)
      );
    switch (actualPage) {
      case 1:
        TagManager.dataLayer({
          dataLayer: {
            event: "update",
            userid: encodedRut,
            tipo_documento: docActual,
          },
        });
        TagManager.dataLayer({
          dataLayer: {
            event: "checkout",
            pageType: "simulador-vespertino",
            event_label: "Ingresar datos",
            userid: encodedRut,
            tipo_documento: docActual,
            ecommerce: {
              checkout: {
                actionField: {
                  step: 3,
                },
              },
            },
          },
        });
        break;
      case 2:
        TagManager.dataLayer({
          dataLayer: {
            event: "checkout",
            pageType: "simulador-vespertino",
            event_label: "Datos personales",
            userid: encodedRut,
            tipo_documento: docActual,
            ecommerce: {
              checkout: {
                actionField: {
                  step: 4,
                },
              },
            },
          },
        });
        break;
      case 3:
        TagManager.dataLayer({
          dataLayer: {
            event: "checkout",
            pageType: "simulador-vespertino",
            event_label: "Selecciona carrera",
            userid: encodedRut,
            tipo_documento: docActual,
            region: regActual.nombre_region,
            ecommerce: {
              checkout: {
                actionField: {
                  step: 5,
                },
              },
            },
          },
        });
        break;
      case 4:
        TagManager.dataLayer({
          dataLayer: {
            event: "checkout",
            pageType: "simulador-vespertino",
            event_label: "Selecciona sede",
            userid: encodedRut,
            tipo_documento: docActual,
            region: regActual.nombre_region,
            modalidad: modalidadActual[0].nombre_modalidad,
            carrera: carrera.carrera.nombre_carrera,
            ecommerce: {
              checkout: {
                actionField: {
                  step: 6,
                },
              },
            },
          },
        });
        break;
      default:
        break;
    }
  };

  const lastStepTagManager = (data) => {
    const rutCompleto = numDoc
      .replaceAll(".", "")
      .replaceAll("-", "")
      .toLowerCase();
    const buffer = Buffer.from(rutCompleto);
    const encodedRut = buffer.toString("base64");
    const docActual = parseInt(tipoDoc) === 1 ? "RUT" : "PASAPORTE";
    const regActual = regiones.find(
      ({ id_region }) => id_region === parseInt(region)
    );
    const modalidadActual = carreras.filter(({ carreras }) =>
      carreras.find(({ id_carrera }) => id_carrera === carrera.id_carrera)
    );
    TagManager.dataLayer({
      dataLayer: {
        event: "purchase",
        userid: encodedRut,
        tipo_documento: docActual,
        region: regActual.nombre_region,
        modalidad: modalidadActual[0].nombre_modalidad,
        carrera: carrera.carrera.nombre_carrera,
        sede: carrera.carrera_modalidad_sede[0].sede.nombre_sede,
        valor_con_beneficio:
          data.simulacion.informacion_financiera.valor_anual_con_becas,
        ecommerce: {
          transaction_id: data.simulacion.simulacion.id_simulacion,
          affiliation: "simulador-vespertino",
          value: 0,
          tax: 0,
          shipping: 0,
          currency: "CLP",
          items: [
            {
              item_name: carrera.carrera.nombre_carrera,
              item_id: carrera.id_carrera,
              price:
                data.simulacion.informacion_financiera.valor_anual_con_becas,
              item_brand: "VESPERTINO",
              item_category: data.simulacion.simulacion.sede,
              item_category2: modalidadActual[0].nombre_modalidad,
              quantity: 1,
            },
          ],
        },
      },
    });
  };

  const setPageWithTagManager = (pageValue) => {
    tagManagerStepper(page);
    setPage(pageValue);
  };

  const Steps = () => {
    switch (page) {
      case 0:
        return (
          <Home
            handleClick={startSimulacionPage1}
            setShowBackButton={setShowBackButton}
            opening={opening}
            msg={openingMsg}
          />
        );
      case 1:
        return (
          <Step1
            setPage={setPageWithTagManager}
            page={page}
            tipoDoc={tipoDoc}
            setTipoDoc={setTipoDoc}
            tipoDocAlert={tipoDocAlert}
            setTipoDocAlert={setTipoDocAlert}
            numDoc={numDoc}
            setNumDoc={setNumDoc}
            numDocAlert={numDocAlert}
            setNumDocAlert={setNumDocAlert}
            email={email}
            setEmail={setEmail}
            emailAlert={emailAlert}
            setEmailAlert={setEmailAlert}
            captcha={captcha}
            setCaptcha={setCaptcha}
            validation={validation}
          />
        );

      case 2:
        return (
          <Step2
            setPage={setPageWithTagManager}
            page={page}
            nombre={nombre}
            setNombre={setNombre}
            nombreAlert={nombreAlert}
            setNombreAlert={setNombreAlert}
            apellido={apellido}
            setApellido={setApellido}
            apellidoAlert={apellidoAlert}
            setApellidoAlert={setApellidoAlert}
            fechaNac={fechaNac}
            setFechaNac={setFechaNac}
            fechaNacAlert={fechaNacAlert}
            setFechaNacAlert={setFechaNacAlert}
            telefono={telefono}
            setTelefono={setTelefono}
            telefonoAlert={telefonoAlert}
            setTelefonoAlert={setTelefonoAlert}
            region={region}
            setRegion={setRegion}
            regionAlert={regionAlert}
            setRegionAlert={setRegionAlert}
            termycond={termycond}
            setTyc={setTyc}
            validation={validation}
            regiones={regiones}
          />
        );

      case 3:
        return (
          <Step3
            setPage={setPageWithTagManager}
            page={page}
            carrera={carrera}
            setCarrera={setCarrera}
            validation={validation}
            carreras={carreras}
            loader={loader}
          />
        );

      case 4:
        return (
          <Step4
            setPage={setPageWithTagManager}
            sede={sede}
            setSede={setSede}
            validation={validation}
            carrera={carrera}
            setCarreraModalidadSede={setCarreraModalidadSede}
            carrera_modalidad_sede={carrera_modalidad_sede}
          />
        );

      case 6:
        return (
          <Step6
            setPage={setPageWithTagManager}
            certificado={certificado}
            valor_matricula_anual={valor_matricula_anual}
            valor_arancel_anual={valor_arancel_anual}
            valor_beca_matricula_unab={valor_beca_matricula_unab}
            valor_beca_arancel_unab={valor_beca_arancel_unab}
            valor_matricula_anual_unab={valor_matricula_anual_unab}
            valor_anual_con_becas={valor_anual_con_becas}
            valor_mensual_con_becas={valor_mensual_con_becas}
            valor_sede={valor_sede}
            valor_nombre_carrera={valor_nombre_carrera}
            url_pdf={url_pdf}
            caracteristica_1={caracteristica_1}
            caracteristica_2={caracteristica_2}
            caracteristica_3={caracteristica_3}
            setNuevaSimulacion={setNuevaSimulacion}
            loadingFinal={loadingFinal}
            setLoadingFinal={setLoadingFinal}
            permitir_envio={permitir_envio}
            jwt={getLocalStorageJWT()}
          />
        );

      default:
        return <Home />;
        break;
    }
  };
  useEffect(() => {
    if (simulacion !== "") {
      setLoader(false);
    }
  }, [simulacion]);

  const setLocalStorageJWT = (jwt) => {
    localStorage.setItem("jwt", jwt);
  };
  const getLocalStorageJWT = () => {
    const jwt = localStorage.getItem("jwt");
    return jwt;
  };

  const simulacionEnd = (obj) => {
    APIS.simulacionEnd(obj, getLocalStorageJWT())
      .then((response) => {
        const simulacion = response.data.data.simulacion;
        const certificado =
          response.data.data.simulacion.simulacion.id_certificado;

        setCertificado(certificado);
        setValuesStep6(simulacion);
        setCaracteristica_1(
          response.data.data.simulacion.simulacion.caracteristica_1
        );
        setCaracteristica_2(
          response.data.data.simulacion.simulacion.caracteristica_2
        );
        setCaracteristica_3(
          response.data.data.simulacion.simulacion.caracteristica_3
        );
        setPermitirEnvio(response.data.data.permitir_envio);
        lastStepTagManager(response.data.data);
        setLoadingFinal(false);
      })
      .catch(function (error) {
        console.error(error.response);
        const errorRES = error.response?.data?.error_message;
        alert(errorRES);

        setPage(6);
        setLoadingFinal(false);
      });
  };

  const setValuesStep6 = (simulacion) => {
    setValorMatriculaAnual(
      simulacion.informacion_financiera.valor_matricula_anual
    );
    setValorArancelAnual(simulacion.informacion_financiera.valor_arancel_anual);
    setValorMatriculaUnab(
      simulacion.informacion_financiera.valor_beca_matricula_unab
    );
    if ("valor_beca_arancel_unab" in simulacion.informacion_financiera) {
      setValorArancelUnab(
        simulacion.informacion_financiera.valor_beca_arancel_unab
      );
    }
    setValorAnualConBecas(
      simulacion.informacion_financiera.valor_anual_con_becas
    );
    setValorMensualConBecas(
      simulacion.informacion_financiera.valor_mensual_con_becas
    );
    setValorNombreCarrera(simulacion.simulacion.nombre_carrera);
    setValorSede(simulacion.simulacion.sede);
    setUrlPdf(simulacion.simulacion.url_pdf);
  };

  const simulacionStart = (obj) => {
    APIS.simulacionStart(obj)
      .then((response) => {
        const simulacion = response.data.data.id_simulacion;
        setSimulacion(simulacion);
        setNuevaSimulacion(false);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const estudiantePut = (obj) => {
    APIS.estudiantePut(obj, getLocalStorageJWT())
      .then(function (response) {
        setEstudiante(response.data.data);
        if (nueva_simulacion) {
          Start_simulation();
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const parseMonth = (month) => {
    const formated_month = month + 1; //date.Month() va de 0 a 11 = 12 meses
    return formated_month < 10 ? "0" + formated_month : formated_month;
  };

  const parseDay = (day) => {
    return day < 10 ? "0" + day : day;
  };

  const parseDate = (fecha_nacimiento) => {
    const date = new Date(fecha_nacimiento);
    const formated_date =
      date.getUTCFullYear() +
      "-" +
      parseMonth(date.getUTCMonth()) +
      "-" +
      parseDay(date.getUTCDate());
    return formated_date;
  };

  const setInputsStep2 = (estudiante) => {
    setNombre(estudiante.nombre ? estudiante.nombre : "");
    setApellido(estudiante.apellido ? estudiante.apellido : "");
    setTelefono(estudiante.celular ? estudiante.celular.slice(2, 11) : "");
    setFechaNac(
      estudiante.fecha_nacimiento ? parseDate(estudiante.fecha_nacimiento) : ""
    );
    setRegion(estudiante.id_region_egreso ? estudiante.id_region_egreso : "");
  };

  const estudianteGet = () => {
    APIS.estudianteGet(tipoDoc, numDoc)
      .then((res) => {
        const estudiante = res.data.data;
        if (estudiante !== null) {
          setInputsStep2(estudiante);
        } else {
          setNombre("");
          setApellido("");
          setTelefono("");
          setFechaNac("");
          setRegion("");
        }
        setEstudiante(res.data.data);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const getOpeningData = () => {
    APIS.getOpeningData()
      .then((res) => {
        const obj = res.data;
        setOpening(obj.apertura);
        setOpeningMsg(obj.mensaje_cierre);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const Start_simulation = () => {
    const body = {
      email: email,
      id_tipo_documento: tipoDoc,
      numero_documento: numDoc.replace(/\./g, ""),
    };
    APIS.startSimulation(body)
      .then((res) => {
        const estudiante = res.data.estudiante;
        const jwt_Id = res.data.jwt;
        const simulacion = res.data.id_simulacion;
        setLocalStorageJWT(jwt_Id);
        setSimulacion(simulacion);
        setNuevaSimulacion(false);
        if (estudiante !== null) {
          setInputsStep2(estudiante);
        } else {
          setNombre("");
          setApellido("");
          setTelefono("");
          setFechaNac("");
          setRegion("");
        }
        setEstudiante(estudiante);
        setLoading(false);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  useEffect(() => {
    if (page === 0) {
      getOpeningData();
      startSimulacionPage0();
    }
    if (page === 2) {
      //estudianteGet()
      Start_simulation();
    }
    if (page === 3) {
      //setLoading(true)
      const postobject = {
        id_estudiante: estudiante.id_estudiante,
        nombre: nombre,
        apellido: apellido,
        fecha_nacimiento: fechaNac,
        celular: 56 + telefono,
        id_region_egreso: parseInt(region),
        email: email,
        id_tipo_documento: parseInt(tipoDoc),
        numero_documento: numDoc,
      };
      estudiantePut(postobject);
    }
    if (page === 6) {
      let obj = {
        id_carrera_modalidad_sede: carrera_modalidad_sede,
        id_estudiante: estudiante.id_estudiante,
        id_simulacion: simulacion,
      };
      simulacionEnd(obj, getLocalStorageJWT());
    } else {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    if (tipoDoc !== "") {
      APIS.getRegiones().then((res) => {
        const regiones = res.data;
        setRegiones(regiones.data);
      });
    }
  }, [tipoDoc]);

  useEffect(() => {
    if (region !== "") {
      APIS.getCarreras().then((res) => {
        const carreras = res.data;
        setCarreras(carreras.data);
      });
    }
  }, [region]);

  const validation = (actualPage) => {
    switch (actualPage) {
      case 1:
        return validationPage1();
        break;
      case 2:
        return validationPage2();
        break;
      case 3:
        return validationPage3();
        break;
      case 4:
        return validationPage4();
        break;

      default:
        break;
    }
    return true;
  };

  const validarMail = (mail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    } else {
      //setEmailAlert(true)
      return false;
    }
  };

  const validacionesRut = {
    // Valida el rut con su cadena completa "XXXXXXXX-X"
    validaRut: function (rutCompleto) {
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var tmp = rutCompleto.split("-");
      var digv = tmp[1];
      var rut = tmp[0];
      if (digv == "K") digv = "k";
      return validacionesRut.dv(rut) == digv;
    },
    dv: function (T) {
      var M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10))
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },
  };

  const validarRut = (value) => {
    if (validacionesRut.validaRut(value)) {
      return true;
    } else {
      return false;
    }
  };

  const validationPage1 = () => {
    let isOk = true;
    if (tipoDoc === "") {
      isOk = false;
    }

    if (!validarMail(email)) {
      isOk = false;
    }

    if (!validarRut(numDoc)) {
      isOk = false;
    }

    if (captcha === false) {
      isOk = false;
    }
    return isOk;
  };

  const validationPage2 = () => {
    let isOk = true;

    if (nombre === "") {
      isOk = false;
    }

    if (apellido === "") {
      isOk = false;
    }

    if (telefono === "" || telefono.length !== 10) {
      isOk = false;
    }

    if (region === "") {
      isOk = false;
    }

    if (fechaNac === "") {
      isOk = false;
    }

    if (termycond !== true) {
      isOk = false;
    }

    return isOk;
  };

  const validationPage3 = () => {
    let isOk = true;

    if (carrera === "") {
      isOk = false;
    }

    return isOk;
  };

  const validationPage4 = () => {
    let isOk = true;

    if (sede === "") {
      isOk = false;
    }

    return isOk;
  };

  return (
    <div className="App">
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {page === 6 ? null : (
            <>
              <Header page={page} setPage={setPage} />{" "}
            </>
          )}
          {Steps()}
          {page === 0 || page === 6 ? null : (
            <>
              {" "}
              <Footer validation={validation} setPage={setPage} page={page} />
            </>
          )}
        </>
      )}
    </div>
  );
}

export default App;
